exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".unified-task-page {\n  padding: 8px 0;\n}\n.unified-task-page .form-box {\n  margin-top: 10px;\n  padding: 6px 0;\n  padding-right: 10px;\n  border: solid 1px #e2e2e2;\n}\n.unified-task-page .page-box {\n  margin-top: 20px;\n}\n.unified-task-page .table-box {\n  margin-top: 10px;\n}\n.unified-task-page .ark-table-border th,\n.unified-task-page .ark-table-border td {\n  height: 30px;\n}\n", ""]);

// exports
